import { GameFreeSpinsOverlayProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameFreeSpinsOverlayProperties";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { Point } from "pixi.js";
/**
 * FreeSpinsOverlayPortraitProperties.ts
 */
export class FreeSpinsOverlayPortraitProperties extends GameFreeSpinsOverlayProperties {
    constructor() {
        super();
        this.collectionSpineProperties = new SpineProperties(GameStyle.DAB_TRAIL_LONG, Modules.GAME);
        this.maxRandomness = 10;
        this.endTrailBodgeOffset = [
            new Point(-15, 30),
            new Point(-15, 30),
            new Point(-20, 30),
            new Point(35, 30),
            new Point(35, 30),
        ];
        this.targetPositions = [
            [new Point(-300, 800)],
            [new Point(-150, 800)],
            [new Point(-60, 650)],
            [new Point(270, 800)],
            [new Point(340, 800)],
        ];
        this.position.set(512, 973);
    }
}
//# sourceMappingURL=FreeSpinsOverlayPortraitProperties.js.map